export default axios => ({
  getList (payload) {
    return axios.get('user', payload)
  },
  get (id) {
    return axios.get(`user/${id}`)
  }
})
